module.exports = __webpack_public_path__ + "static/media/kits-icon.c634a6c5.svg";